import React from 'react'
import { Card, Typography, Badge } from 'antd'
import { ExclamationCircleFilled, CalendarOutlined } from '@ant-design/icons'
import '../../../styling/HealthWarnings.css'

const { Text, Title } = Typography

const HealthWarnings = ({ warnings = [] }) => {
  if (!warnings.length) return null

  // Format date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  }

  return (
    <div className='cs-health-warnings'>
      <div className='cs-warnings-header'>
        <Title level={5}>
          <ExclamationCircleFilled className='cs-warning-icon' />
          Health Warnings
        </Title>
        <Badge count={warnings.length} className='cs-warnings-count' />
      </div>

      <div className='cs-warnings-list'>
        {warnings.map((warning, index) => (
          <Card key={index} className='cs-warning-card'>
            <div className='cs-warning-content'>
              <div className='cs-warning-text'>
                <Text className='cs-warning-message'>{warning.text}</Text>
                <div className='cs-warning-date'>
                  <CalendarOutlined />
                  <Text type='secondary'>Added: {formatDate(warning.timestamp)}</Text>
                </div>
              </div>
              <ExclamationCircleFilled className='cs-warning-indicator' />
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default HealthWarnings
